<template>
  <div class="CompanyCollection">
    <div class="content flex-jc-bt flex-no-wrap">
      <div class="flex-85 left-side">
        <sp-card type="none">
          <div class="card-content">
            <div class="buttons flex flex-al-center pd-b-20">
              <sp-button to="addCompany" :width="0.12" :height="44" circle-radius="5" type="warn" :bold="400" :font="18" :label="$l('AddNewCompany')" />
              <div class="flex flex-al-center mg-l-20">
                <div class="flex-al-center fw-bold opacity-80 sp-color-7">{{ $l('CompanyNameEnglish') }}</div>
                <div class="mg-l-10">
                  <sp-input v-model="filterForm.name" type="grayBorder1"
                            height="34" width="230" class="filter-select" placeholder=" " />
                </div>
                <div class="flex-al-center fw-bold mg-l-20 opacity-80 sp-color-7">{{ $l('CountryOrSAR') }}</div>
                <div class="mg-l-10">
                  <sp-select v-model="filterForm.countryId" type="grayBorder1"
                             height="34" width="230" placeholder=" ">
                    <sp-select-option v-for="item in countrys" :key="item.id" :label="item.name" :value="item.id" />
                  </sp-select>
                </div>
                <sp-button class="mg-l-20" :width="87" :height="34" circle :label="$l('Search')" @click="getListing" />
              </div>
            </div>
            <SpTable v-model:currPage="currPage" show-arrow column-height="114" :data-list="dataList" width="1" class="table" :total="total" :page-size="pageSize">
              <SpTableColumn column-name="id" label="No" />
              <SpTableColumn label="LinkedOCNode">
                <template #default="row">
                  {{ row.node?.title }}
                </template>
              </SpTableColumn>
              <SpTableColumn column-name="serialNo" label="CompanySerialNo" :ellipse="true" width="200" />
              <SpTableColumn column-name="codeName" label="CodeName" />
              <SpTableColumn class="column" column-name="name" label="CompanyName">
                <template #default="row">
                  <SpTooltip>
                    <div class="column-main ellipsis">{{ row.name }}</div>
                    <div class="column-attach ellipsis">{{ row.nativeName }}</div>
                  </SpTooltip>
                </template>
              </SpTableColumn>
              <!-- <SpTableColumn column-name="CompanyNameC" /> -->
              <SpTableColumn column-name="CountryOrSAR">
                <template #default="row">
                  {{ row.country?.name }}
                </template>
              </SpTableColumn>
              <SpTableColumn column-name="CompanyCategory">
                <template #default="row">
                  <p>{{ $l(companyCategory[row.identity]?.title) }}</p>
                  <p v-if="row.privContact">{{ $l(companyCategory['privContact']?.title) }}</p>
                  <p v-if="row.privSign">{{ $l(companyCategory['privSign']?.title) }}</p>
                </template>
              </SpTableColumn>
              <SpTableColumn column-name="Position" width="200">
                <template #default="row">
                  <span>{{ $l(companyPosition[row.level]?.title) }}</span>
                </template>
              </SpTableColumn>
              <SpTableColumn label="Staff" column-name="staffCount" />
              <SpTableColumn column-name="More">
                <template #default="row">
                  <SpIcon :ref="'more'+row.$index" class="pointer" type="more" @click="showMoreDialog(row.$index,$event)" />
                </template>
              </SpTableColumn>
              <SpTableColumn column-name="Action" :fixed="true" width="100">
                <template #default="row">
                  <div class="flex-jc-ard">
                    <SpIcon type="edit" :class="{disabledIcon: row.creatorId === userId}" :disabled="row.creatorId === userId" @click="toEditPage(row)" />
                    <SpIcon type="heart" :class="{disabledIcon: row.creatorId === userId}" :disabled="row.creatorId === userId" @click="showCollectionDialog(row)" />
                  </div>
                </template>
              </SpTableColumn>
              <template #expand="row">
                <div class="expand flex">
                  <div>
                    <div class="expand-item sp-color-2">{{ $l('DepartmentsAvailable')+' ('+row.departments?.length+')' }}</div>
                    <div class="progress-bar" :class="{'blue' : row.departments?.length >0}" />
                    <router-link class="expand-item sp-color-2" :to="{name: 'addDepartment', query: {nodeId: row.nodeId}}">{{ $l('AddNewDepartment') }}</router-link>
                  </div>
                </div>
              </template>
            </SpTable>
          </div>
        </sp-card>
      </div>
      <div class="flex-10 right-side">
        <SpTable :data-list="dataList" width="1" class="table" column-height="114">
          <SpTableColumn column-name="EnteredBy">
            <template #default="row">
              <div>{{ row.creatorName }}</div>
              <!--              {{ $FormatDate() }} -->
              <div class="column-attach">
                {{ getDateToFormatEn(row.sourceCreatedAt) }}
              </div>
            </template>
          </SpTableColumn>
          <template #expand>
            <div class="expand" />
          </template>
        </SpTable>
      </div>
    </div>
    <SpDrawer v-model="showMore" dragable :popup-trigger="$refs[`more${popupTrigger}`]" :offset-top="20"
              close-on-press-escape direction="center-offset" width="0.9" height="0.7" type="dialog" :mask="false">
      <CompanyDetail :id="checkItem.id" />
    </SpDrawer>
    <SpDrawer v-model="showCollection" width="500" height="430" type="dialog">
      <p class="pd-l-20 pd-r-20 sp-color-7">
        Please clarify at which node of organization chart you want to add the new company，
      </p>
      <p class="pd-l-20 pd-r-20">Please select a node:</p>
      <div class="mg-b-20 xuxian" />
      <div class="pd-l-20 pd-r-20">
        <SpRadioGroup v-model="nodeId" :cancelable="false" class="potion text-left">
          <SpRadio v-for="node in linkedOCNodes" :key="node.id" :value="node.id" name="position">
            <span class="potion-item-span sp-color-7">{{ node.title }}</span>
          </SpRadio>
        </SpRadioGroup>
      </div>

      <div class="btn-bar mg-t-30">
        <sp-button type="cancleLight" height="42" width="136" @click="showCollection = false">{{ $l('Cancel') }}</sp-button>
        <sp-button class="mg-l-80" type="confirm" height="42" width="136" @click="collectionCompany">{{ $l('Confirm') }}</sp-button>
      </div>
    </SpDrawer>
  </div>
</template>

<script type="text/ecmascript-6">
import { enterpriseCorpCopyApi, getCompanyBySearchApi, getEnterpriseStructure } from '@/request/APIs/company'
import spCard from '@/components/common/SpCard'
import spInput from '@/components/common/SpInput'
import SpIcon from '@/components/common/SpIcon.vue'
import spButton from '@/components/common/SpButton'
import SpTable from '@/components/common/SpTableDIY/SpTable.vue'
import SpTableColumn from '@/components/common/SpTableDIY/SpTableColumn.vue'
import spSelect from '@/components/common/SpSelect'
import spSelectOption from '@/components/common/SpSelectOption'
import { COMPANY_CATEGORY, COMPANY_POSITION } from '@/config/company'
import SpDrawer from '@/components/common/SpDrawer'
import CompanyDetail from '@/components/company/companyDynamics/CompanyDetail'
import SpRadioGroup from '@/components/common/SpRadioGroup'
import SpRadio from '@/components/common/SpRadio'
import { getDateToFormatEn } from '@/utils/convert'
import { getCountrySpareList, searchAddress } from '@/request/APIs/common'
import SpMessage from '@/components/common/SpMessage'
export default {
  name: 'CompanyCollection',

  nameSpace: 'company.CompanyCollection',

  components: {
    spCard,
    spButton,
    SpTable,
    SpTableColumn,
    spSelect,
    spSelectOption,
    spInput,
    CompanyDetail,
    SpIcon,
    SpDrawer,
    SpRadioGroup,
    SpRadio
  },

  props: {
  },

  data () {
    return {
      currPage: 1,
      total: 0,
      pageSize: 0,
      dataList: [],
      filterForm: {
        name: '',
        countryId: null
      },

      countrys: [],
      companyCategory: COMPANY_CATEGORY,

      companyPosition: COMPANY_POSITION,
      getDateToFormatEn,
      checkItem: {},
      showMore: false,
      popupTrigger: 0,
      showCollection: false,
      linkedOCNodes: [],
      nodeId: null,
      sourceId: null
    }
  },

  computed: {
    userId () {
      return this.$store.state.user.user.id
    }
  },

  watch: {
    currPage (n) {
      this.getListing()
    }
  },

  created () {
    if (localStorage.getItem('countrysSpare')) {
      this.countrys = JSON.parse(localStorage.getItem('countrysSpare'))
    } else {
      getCountrySpareList().then((res) => {
        this.countrys = res.data
        localStorage.setItem('countrysSpare', JSON.stringify(res.data))
      })
    }
    this.getListing()
    this.getEnterpriseStructureNodes()
  },

  mounted () {
  },

  methods: {
    getListing () {
      getCompanyBySearchApi({ ...this.filterForm, page: this.currPage }).then(res => {
        this.dataList = res.data.data
        this.total = res.data.total
        this.pageSize = res.data.pageSize
      })
    },

    getCountrys (keyWord) {
      searchAddress({
        type: 'country',
        keyWord: keyWord
      }).then(res => {
        this.countrys = res.data
      })
    },

    showMoreDialog (index, e) {
      this.popupTrigger = index
      this.checkItem = this.dataList[index]
      this.showMore = true
    },

    showCollectionDialog (row) {
      this.nodeId = null
      this.showCollection = true
      this.sourceId = row.id
    },

    // 收藏
    collectionCompany () {
      enterpriseCorpCopyApi(this.sourceId, this.nodeId).then(res => {
        SpMessage({
          message: res.message,
          type: 'success'
        })
      })
    },

    getEnterpriseStructureNodes () {
      const random = Math.random().toString()
      getEnterpriseStructure(random).then(res => {
        this.linkedOCNodes = [res.data.master, ...res.data.subs]
      })
    },

    // 跳转到编辑页面
    toEditPage (item) {
      this.$router.push({
        name: 'addCompany',
        query: { id: item.id, type: 'copy' }
      })
    }
  }
}
</script>

<style scoped lang="less">
.CompanyCollection{
  .content{
    padding: @gap*2 @gap @gap @gap;
    .left-side{
      overflow: hidden;
      .card-content{
        padding: @gap 0 @gap @gap;
        position: relative;
      }
      .table{
        padding-top: @gap;
        .expand{
          margin-top: @gap;
        }
        .expand-item{
          opacity: 0.5;
          font-weight: normal;
        }
        .progress-bar{
          width: 191px;
          height: 9px;
          background: #72BEDE;
          margin: @gap/2 0 @gap/2 0;
        }
      }
    }
    .right-side{
      background-color: white;
      padding: @gap*4.1 @gap @gap @gap;
      margin: @gap*2 @gap @gap @gap;
    }
  }
  .disabledIcon{
    cursor: not-allowed;
    opacity: 0.6;
  }
}
.xuxian {
  height: 1px;
  border-top: 1px gray dashed;
}
.potion-item-span{
  line-height: 40px;
  display: inline-block;
  width: 100%;
  border-bottom: 1px dashed gray;
}
.btn-bar {

  text-align: center;
  .SpButton {
    display: inline-block;
  }

}
</style>
